import React from 'react';
import { Stack, Typography } from '@mui/material';

interface Props<Context extends any = any> {
  context: Context;
  selected: string[];
  bulkActions: (renderProps: { context: Context; selected: string[] }) => React.ReactNode;
}

export const BulkActionsPanel = <Context extends any = any>({ context, selected, bulkActions }: Props<Context>) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: '0.3rem',
        backgroundColor: 'black',
        padding: '0.3rem 0.5rem',
        justifyContent: 'space-between',
      }}
    >
      {!!selected.length && <Typography sx={{ color: 'white' }}>{selected.length} selected</Typography>}

      {bulkActions({ context, selected })}
    </Stack>
  );
};
